import { useState } from "react";
import { ChevronRight } from "lucide-react";

interface CollapsibleSectionProps {
  title: string;
  /** Optional right-aligned content in the header (e.g. an add button). */
  action?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
  /** Controlled open state. When provided, the parent owns open/close. */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/** A titled section with a disclosure toggle to save vertical space. */
export function CollapsibleSection({
  title,
  action,
  defaultOpen = true,
  children,
  open: openProp,
  onOpenChange,
}: CollapsibleSectionProps) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const controlled = openProp !== undefined;
  const open = controlled ? openProp : internalOpen;
  const toggle = () => {
    const next = !open;
    if (!controlled) setInternalOpen(next);
    onOpenChange?.(next);
  };
  return (
    <section>
      <div className="mb-2 flex items-center justify-between">
        <button
          type="button"
          onClick={toggle}
          aria-expanded={open}
          className="flex items-center gap-1.5 font-medium text-slate-800"
        >
          <span
            className={`text-slate-400 transition-transform ${
              open ? "rotate-90" : ""
            }`}
          >
            <ChevronRight size={14} />
          </span>
          {title}
        </button>
        {open && action}
      </div>
      {open && children}
    </section>
  );
}
